import { render } from "./CommentInput.vue?vue&type=template&id=0deea7cf&scoped=true"
import script from "./CommentInput.vue?vue&type=script&lang=js"
export * from "./CommentInput.vue?vue&type=script&lang=js"

import "./CommentInput.vue?vue&type=style&index=0&id=0deea7cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0deea7cf"]])

export default __exports__